import React from "react";
import { Button, Row, Col, Modal } from "react-bootstrap";
import UserImage from "../../assets/img/property-placeholder.jpg";
import {
  fetchUserTransactionAction,
  getInformationByIdAction,
  getUserRolesActionNew,
} from "../../actions/UserActions";
import { connect } from "react-redux";
import * as code from "../../config/Constants";
import PhoneNumber from "../Common/phoneNumber";
import UrlConstants from "../../config/UrlConstants";
import { withRouter } from "react-router-dom";
import { toTitleCase, cryptoTokenDecode } from "../Common/Common";
import ReactPaginate from "react-paginate";
import { Tune } from "@material-ui/icons";
import * as message from "../../config/CommonMessages";
import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { UploadFile } from "@mui/icons-material";
/**
 * @desc created component for view contact details
 */
class ViewContact extends React.Component {
  constructor(props) {
    super(props);

    let userType = cryptoTokenDecode().usertype;

    this.state = {
      userType: userType.toUpperCase(),
      contactTransactionData: [],
      contactData: {},
      roleId: "",
      page: 0,
      PageSize: 6,
      pageCount: 0,
      inprogressState: "INPROGRESS",
      completeState: "",
      cancleState: "",
      draftChecked: true,
      inProgressChecked: true,
      pauseChecked: true,
      completedChecked: false,
      canceledChecked: false,
      showHideFilter: false,
    };
  }
  componentDidMount() {
    this.props.getUserRolesActionNew().then((roleList) => {
      let roleObj = {};
      if (this.props.roleForPopup === "Client") {
        roleObj = roleList.find((o) => o.name === "Client");
      }
      if (this.props.roleForPopup === "Artist") {
        roleObj = roleList.find((o) => o.name === "Artist");
      }
      let roleIdVar = roleObj ? roleObj._id : "";
      this.setState({ roleId: roleIdVar });
      this.props
        .getInformationByIdAction(
          this.props.contactData && this.props.contactData._id,
          roleIdVar
        )
        .then((res) => {
          this.setState({ contactData: res.data.data });
        });
    });

    this.getTransactionPaginate();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.page !== this.state.page &&
      prevState.PageSize === this.state.PageSize
    ) {
      this.getTransactionPaginate();
    }
    if (prevState.inprogressState !== this.state.inprogressState) {
      this.getTransactionPaginate();
    }
    if (prevState.completeState !== this.state.completeState) {
      this.getTransactionPaginate();
    }
    if (prevState.cancleState !== this.state.cancleState) {
      this.getTransactionPaginate();
    }
    if (prevState.PageSize !== this.state.PageSize) {
      this.getTransactionPaginate();
    }
  }

  getTransactionPaginate = () => {
    let data = {
      inprogressState: this.state.inprogressState,
      completeState: this.state.completeState,
      cancleState: this.state.cancleState,
      id: this.props.contactData && this.props.contactData._id,
      PageSize: this.state.PageSize,
      page: this.state.page,
    };

    this.props.fetchUserTransactionAction(data).then((res) => {
      this.setState({
        contactTransactionData: res.data.data,
        pageCount: res.data.total,
      });
    });
  };

  handlePageClick = (event) => {
    this.setState({ page: event.selected });
  };

  setStatusFilter() {
    this.setState({ showHideFilter: !this.state.showHideFilter });
  }

  filterByStatus(e) {
    if (e === "INPROGRESS") {
      if (this.state.inProgressChecked === true) {
        this.setState({ inProgressChecked: !this.state.inProgressChecked });
        this.setState({ inprogressState: "" });
      } else {
        this.setState({ inProgressChecked: !this.state.inProgressChecked });
        this.setState({ inprogressState: "INPROGRESS" });
      }
    } else if (e === "COMPLETED") {
      if (this.state.completedChecked === true) {
        this.setState({ completedChecked: !this.state.completedChecked });
        this.setState({ completeState: "" });
      } else {
        this.setState({ completedChecked: !this.state.completedChecked });
        this.setState({ completeState: "COMPLETED" });
      }
    } else {
      if (this.state.canceledChecked === true) {
        this.setState({ canceledChecked: !this.state.canceledChecked });
        this.setState({ cancleState: "" });
      } else {
        this.setState({ canceledChecked: !this.state.canceledChecked });
        this.setState({ cancleState: "CANCELED" });
      }
    }
  }

  render() {
    return (
      <>
        {/* <Modal.Body className="pb-0"> */}
        <Row>
          <Col xs="12" sm="3">
            <div className="profile-img profile-img-big">
              <img
                src={
                  this.state.contactData &&
                  this.state.contactData.avatar &&
                  this.state.contactData.avatar !== "-"
                    ? UrlConstants.AdminCreateTransactionUrl +
                      "/upload?id=" +
                      this.state.contactData._id +
                      "&img=" +
                      this.state.contactData.avatar
                    : UserImage
                }
                alt="user"
              />
            </div>
            {/* {this.state.userType === message.ACCTOWNER ? (
              <IconButton
                onClick={() =>
                  this.props.history.push({
                    pathname: "/uploadPersonalDocuments",
                    state: {
                      id:
                        this.props.contactData &&
                        this.props.contactData.contactId,
                    },
                  })
                }
              >
                <Tooltip title="Upload Personal Docs">
                  <UploadFile />
                </Tooltip>
              </IconButton>
            ) : (
              ""
            )} */}
          </Col>
          <Col xs="12" sm="9">
            <Row className="mb-2">
              <Col xs={12} sm={6}>
                <div className="font-12 color-grey-1 font-500">First Name</div>
                <div className="font-12 mb-2">
                  {this.state.contactData && this.state.contactData.firstname
                    ? this.state.contactData.firstname
                    : "-"}
                </div>
              </Col>

              <Col xs={12} sm={6}>
                <div className="font-12 color-grey-1 font-500">Last Name</div>

                <div className="font-12 mb-2">
                  {this.state.contactData && this.state.contactData.lastname
                    ? this.state.contactData.lastname
                    : "-"}
                </div>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xs={12} sm={6}>
                <div className="font-12 color-grey-1 font-500">Email</div>
                <div className="font-12 mb-2">
                  {this.state.contactData &&
                  this.state.contactData.email &&
                  this.state.contactData.email.address
                    ? this.state.contactData.email.address
                    : "-"}
                </div>
              </Col>

              <Col xs={12} sm={6}>
                <div className="font-12 color-grey-1 font-500">
                  Phone (Mobile)
                </div>

                <div className="font-12 mb-2">
                  {this.state.contactData &&
                  this.state.contactData.mobileNumber ? (
                    <PhoneNumber
                      phoneNumber={this.state.contactData.mobileNumber}
                    />
                  ) : (
                    "-"
                  )}
                </div>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xs={12} sm={6}>
                <div className="font-12 color-grey-1 font-500">Role</div>
                <div className="font-12 mb-2">
                  {this.state.contactData &&
                  this.state.contactData.roles &&
                  this.state.contactData.roles.length > 0 &&
                  this.state.contactData.roles[0] &&
                  this.state.contactData.roles[0].name
                    ? toTitleCase(this.state.contactData.roles[0].name)
                    : "-"}
                </div>
              </Col>

              <Col xs={12} sm={6}>
                <div className="font-12 color-grey-1 font-500">
                  Phone (Office)
                </div>

                <div className="font-12 mb-2">
                  {this.state.contactData &&
                  this.state.contactData.otherNumber ? (
                    <PhoneNumber
                      phoneNumber={this.state.contactData.otherNumber}
                    />
                  ) : (
                    "-"
                  )}
                </div>
              </Col>
            </Row>
            {this.state.contactData &&
              this.state.contactData.dsd &&
              this.state.contactData.dsd.roles &&
              this.state.contactData.dsd.roles[0] &&
              this.state.contactData.dsd.roles[0].roleName === "Client" && (
                <Row className="mb-2">
                  <Col xs={12} sm={6}>
                    <div className="custom-control custom-checkbox font-12 font-500">
                      <input
                        disabled={true}
                        value={this.state.contactData.dsd.isTextMsgEnabled}
                        checked={this.state.contactData.dsd.isTextMsgEnabled}
                        type="checkbox"
                        className="custom-control-input green-checkbox"
                        id="isTextMsgEnabled"
                        name="isTextMsgEnabled"
                      />
                      <label className="custom-control-label">
                        Opted In to receive text Messages
                      </label>
                    </div>
                  </Col>
                </Row>
              )}
            <hr className="mt-1" />
            <Row className="mb-4">
              <Col className="col-auto pr-0">
                <h2 className="color-black font-20 mb-0">Artwork Details</h2>
              </Col>
              <Col align="right" className="pl-0 multi-permit">
                <Button
                  variant="primary"
                  className="btn-blue btn-head"
                  onClick={() => {
                    this.setStatusFilter();
                  }}
                  style={{
                    backgroundColor: "black",
                    border: "none",
                    marginTop: "1px",
                  }}
                >
                  <Tune style={{ color: "white" }} />
                </Button>
                {this.state.showHideFilter && (
                  <ul style={{ listStyleType: "none", width: "200px" }}>
                    <li>
                      <input
                        type="checkbox"
                        value="INPROGRESS"
                        checked={this.state.inProgressChecked}
                        onChange={(e) => {
                          this.filterByStatus("INPROGRESS");
                        }}
                      />
                      In Progress
                    </li>
                    <li>
                      <input
                        type="checkbox"
                        value="COMPLETED"
                        checked={this.state.completedChecked}
                        onChange={(e) => {
                          this.filterByStatus("COMPLETED");
                        }}
                      />
                      Completed
                    </li>
                    <li>
                      <input
                        type="checkbox"
                        value="CANCELED"
                        checked={this.state.canceledChecked}
                        onChange={(e) => {
                          this.filterByStatus("CANCELED");
                        }}
                      />
                      Canceled
                    </li>
                  </ul>
                )}
              </Col>
            </Row>
            <Row className="mb-4">
              {this.state.contactTransactionData &&
              this.state.contactTransactionData.length > 0 ? (
                this.state.contactTransactionData.map((trans) => {
                  return (
                    <Col xs={12} sm={4} className="mb-4">
                      <div className="font-12 mb-2">
                        <span className="color-grey-1 font-500">
                          Artwork ID :
                        </span>
                        <span
                          style={{ cursor: "pointer" }}
                          className="color-light-blue-1 font-500"
                          onClick={() => {
                            this.props.history.push({
                              pathname: "/artwork/detail/" + trans._id,
                            });
                          }}
                        >
                          {" "}
                          {trans.shortName ? trans.shortName : "-"}
                        </span>
                      </div>
                      <div className="font-12 mb-2">
                        <span className="color-grey-1 font-500">
                          Description :
                        </span>
                        <span> {trans.heldBy ? trans.heldBy : "-"}</span>
                      </div>
                      <div className="font-12">
                        <span className="color-grey-1 font-500">Status :</span>
                        <span> {trans.status ? trans.status : "-"}</span>
                      </div>
                    </Col>
                  );
                })
              ) : (
                <Col xs={12} sm={4} className="mb-4">
                  <span className="font-12">{"No data found"}</span>
                </Col>
              )}
            </Row>
            <Row className="mb-4 justify-content-center">
              {this.state.contactTransactionData &&
                this.state.contactTransactionData.length > 0 && (
                  <div>
                    <ReactPaginate
                      previousLabel={"previous"}
                      nextLabel={"next"}
                      breakLabel={"..."}
                      pageCount={this.state.pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={this.handlePageClick}
                      containerClassName={"pagination justify-content-center"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                    />
                  </div>
                )}
            </Row>
          </Col>
        </Row>
        {/* </Modal.Body> */}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default withRouter(
  connect(
    mapStateToProps,
    {
      fetchUserTransactionAction,
      getInformationByIdAction,
      getUserRolesActionNew,
    }
  )(ViewContact)
);
